import styled from "@emotion/styled";
import type { HtmlHTMLAttributes, ReactNode } from "react";

import { FONT_WEIGHT_MEDIUM, PAGE_SIDE_PADDING } from "../utilities/constants";

type Props = HtmlHTMLAttributes<HTMLDivElement> & {
  children: ReactNode;
  header?: ReactNode;
};

export const PageSection = ({ children, header, ...domAttrs }: Props) => {
  return (
    <SectionWrapper {...domAttrs}>
      {header && <SectionHeader>{header}</SectionHeader>}
      {children}
    </SectionWrapper>
  );
};
const SectionWrapper = styled.div`
  background: ${({ theme }) => theme.surface};
  border-radius: 8px;
`;

const SectionHeader = styled.div`
  padding: 20px ${PAGE_SIDE_PADDING / 2}px;
  border-bottom: solid 1px ${({ theme }) => theme.outlineSoft};

  h3 {
    font-weight: ${FONT_WEIGHT_MEDIUM};
    font-size: 20px;
    margin: 0;
  }

  p {
    margin: 10px 0 0 0;
    color: ${({ theme }) => theme.generalTextIconVariant};
    font-size: ${({ theme }) => theme.fontSizeLarge};
  }
`;
